<template>
    <NewShipAndReceiving></NewShipAndReceiving>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);

const NewShipAndReceiving = defineAsyncComponent(() =>
    import(
        "../../components/Logistics/NewShipReceiving/NewShipAndReceiving.vue"
    )
);

export default {
    name: "Logistics_NewShipAndReceiving",
    components: { NewShipAndReceiving, AuthLayout },
};
</script>
